import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feedback-stats-quarter',
  templateUrl: './feedback-stats-quarter.component.html',
  styleUrls: ['./feedback-stats-quarter.component.css']
})
export class FeedbackStatsQuarterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
